import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./Reducer/AuthReducer"; // Ensure correct path
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // Uses local storage
import {encryptTransform} from "redux-persist-transform-encrypt";


const encryptor = encryptTransform({
  secretKey : process.env.REACT_APP_PERSIST_SECRET,
  onError: (error) => {
    console.error("Redux Persist Encryption Error:", error);
  },
})

const persistConfig = {
  key: "auth",
  storage,
  whitelist: ["user", "role"], // Persist only user details
  transforms: [encryptor],
  
};

const persistedReducer = persistReducer(persistConfig, authReducer);

export const store = configureStore({
  reducer: {
    auth: persistedReducer, // ✅ Ensure "auth" matches the key used in `useSelector`
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }),
  devTools: false,
});


export const persistor = persistStore(store);
